<!-- Copyright 2017 Daimler Truck Financial Services USA LLC -->

<section class="mbfs-server-errors page-not-found">
  <div class="mbfs-server-errors-hero-wrapper">
    <section class="mbfs-server-errors-hero">
      <section class="mbfs-server-errors-hero__header">
        <h2 class="mbfs-server-errors-hero__header-subtitle">
           {{'PageNotFound.Title' | translate }}
        </h2>
        <p class="mbfs-server-errors-hero__header-text-demi">
          {{'PageNotFound.Message' | translate }}
         </p>
        <div class = "listbox">
          <a class="mbfs-button" href="{{this.targetRedirect}}">{{'PageNotFound.RedirectLink' | translate }}</a>
      </div>
      </section>
    </section>
  </div>
</section>
